export const ACTIVATE_LAYER = 'ACTIVATE_LAYER';
export const DEACTIVATE_LAYER = 'DEACTIVATE_LAYER';
export const INIT_LAYERS_CONF = 'INIT_LAYERS_CONF';

export const activateLayer = layer => {
  return {
    type: ACTIVATE_LAYER,
    payload: layer
  };
};

export const deactivateLayer = layer => {
  return {
    type: DEACTIVATE_LAYER,
    payload: layer
  };
};

export const initLayersConf = conf => {
  return {
    type: INIT_LAYERS_CONF,
    payload: conf
  };
};